export default __webpack_public_path__ + "static/media/nodejs.bc23e0a2.svg";